module.exports = {"header":"Online Chat","notSupportedBrowser":"Мы не поддерживаем браузер Internet Explorer","input_placeholder":"Сообщение...","header_title_first":"Онлайн","header_title_second":"Чат","viewed":"Просмотрено","connection_problem":"Проблема соединения","refresh_page":"Пожалуйста, обновите страницу"}


//////////////////
// WEBPACK FOOTER
// ./src/components/locale/ru.json
// module id = 243
// module chunks = 0